import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { CollaboratorsService } from "../../../collaborators.service";

@Component({
  selector: "app-transformation-select",
  templateUrl: "./transformation-select.component.html",
  styleUrls: ["./transformation-select.component.scss"],
})
export class TransformationSelectComponent implements OnInit {
  public collaboratorHash: any = "";

  public collaboratorList: any = [];

  constructor(
    public router: Router,
    public _utilService: UtilsService,
    private _collaboratorsService: CollaboratorsService,
  ) {
    this._utilService.disableAutoHideLoading();
  }

  async ngOnInit() {
    this.collaboratorList = await this._collaboratorsService.getCollaboratorList();
    this.collaboratorList.map((collaborator: any) => {
      if (collaborator.business_name) {
        collaborator.label = collaborator.business_name;
      } else {
        collaborator.label = collaborator.complete_name;
      }
    });
    this._utilService.hideLoading();
  }

  async transformCollaborateToEmployee(collaboratorHash: string) {
    await this.router.navigateByUrl("/dashboard/transformation-create/" + collaboratorHash);
  }
}
